import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import CreateAction from '@/components/ribbon-actions/CreateAction';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import { findSelectedInCategory } from '@/utils/resultsHelper';
import urls, { codeUrl } from '@/constants/urls';
import { fetchUserGroups } from '../actions/usergroups/read';
import { showDeleteUserGroupsDialog } from '../actions/usergroups/delete';
import UsersLauncherMenu from '../../components/UsersLauncherMenu';

const UserGroupsActions = ({
  allowCreate,
  allowDelete,
  allowRefresh,
  allowUsers,
  category,
  code,
  deleteDisabled,
  fetchGroups,
  readStatus,
  showDelete,
}) => (
  <>
    {allowCreate && (<CreateAction url={codeUrl(urls.USER_GROUP, code, '#')} />)}
    {allowRefresh && (
      <RefreshActionMenu
        onClick={() => fetchGroups(category, 1)}
        disabled={readStatus === states.PENDING}
      />
    )}
    {allowDelete && (<DeleteActionMenu onClick={() => showDelete(category)} disabled={deleteDisabled} />)}
    {allowUsers && (<UsersLauncherMenu />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions } },
  userGroups: { newUserGroupCode, userGroups },
}, { category }) => {
  const selectedUserGroups = findSelectedInCategory(userGroups, category);

  return {
    allowCreate: permissions.usergroups.create,
    allowRefresh: permissions.usergroups.read,
    allowDelete: permissions.usergroups.destroy,
    allowUsers: permissions.users.read,
    readStatus: userGroups[category].readStatus,
    code: newUserGroupCode,
    deleteDisabled: !selectedUserGroups?.length,
  };
};

const mapDispatchToProps = {
  fetchGroups: fetchUserGroups,
  showDelete: showDeleteUserGroupsDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupsActions);
